import { State } from "reducers";
import { createSelector } from "reselect";

export const getWebSocketState =
    (state: State) => state.ws;

export const getWebSocketConnected =
    createSelector(
        getWebSocketState,
        state => state.connected
    );

export const getWebSocketConnecting =
    createSelector(
        getWebSocketState,
        state => state.connecting
    );
